export default {
  // 登录页
  login: {
    lang: '语言',
    systemname: '人脸设备后台登录',
    username: '用户名',
    username_label: '请输入用户名',
    pwd: '密码',
    pwd_label: '请输入密码',
    pwd_info: '请输入正确密码格式',
    success_msg: '登录成功',
    error_name: '密码错误',
    error_res: '不符合登录要求',
    login: '登录',
  },
  // 侧边栏部分
  aside: {
    systemname: '人脸设备后台',
    quit: '退出',
    deviceControl: '设备控制',
    basicSetting: '基础设置',
    workerSetting: '人员设置',
    deviceMonitoring: '设备监控',
    recordManagement: '记录管理',
    securityManagement: '密钥管理',
    tips: '提示',
    tips_msg: '是否退出登录',
  },
  // 设备控制页面
  control: {
    remoteControl: '远程控制',
    restart: '设备重启',
    clickToRestart: '点击重启设备',
    restartConfirm: '确定要重启设备吗？',
    restartSuccess: '重启成功',
    restartFailed: '重启失败',
    remoteOpen: '远程开门',
    clickToOpen: '点击远程开门',
    openConfirm: '确定要远程开门吗？',
    remoteOpenSuccess: '远程开门成功',
    remoteOpenFailed: '远程开门失败',
    reset: '设备重置',
    clickToReset: '点击重置设备',
    resetConfirm: '确定要重置设备吗？',
    resetSuccess: '设备重置成功',
    resetFailed: '设备重置失败',
    firmwareUpgrade: '设备升级',
    upgradeConfig: '升级配置',
    firmwareUrl: '固件地址',
    md5Checksum: 'md5值',
    startUpgrade: '开始升级',
    urlRequired: '文件地址必填',
    md5Required: 'md5值必填',
    urlInvalid: '请输入正确的地址',
    md5Invalid: '请输入正确的md5',
    upgradeConfirm: '确定升级设备吗？',
    upgradeSuccess: '设备升级成功',
    clearFile: "清除文件",
    uploading: '上传升级中...',
    uploadAndUpgrade: '上传并升级',
    restartTips: '安全重启设备系统，不会丢失数据',
    restarting: '重启中...',
    remoteTips: '远程控制门禁设备开启',
    opening: '开门中...',
    resetTips: '恢复出厂设置，清除所有数据',
    reseting: '重置中...',
    urlUpgrade: 'URL升级方式',
    fileUpgrade: '文件上传升级',
    uploadFile: '点击上传固件文件',
    formatFile: '支持 .zip 或 .dpk 格式文件，最大 20MB',
    fileName: '文件名',
    size: '大小',
  },
  // 基础设置页面
  config: {
    second: '秒',
    millisecond: '毫秒',
    min: '分钟',
    notsave: '不保存',
    save: '保存',
    noVoice: '无语音',
    no: '否',
    yes: '是',
    // 基础配置
    basicConfiguration: '基础配置',
    displaySettings: '显示设置',
    informationDisplay: '信息显示',
    audioSettings: '音频设置',
    languageAndThemes: '语言与主题',
    autoAdjustScreenBrightness: '自动调节屏幕亮度',
    screenBrightness: '屏幕亮度',
    autoTurnOffScreen: '自动息屏',
    autoTurnOffScreenTime: '自动息屏时间',
    autoScreenSaver: '自动屏保',
    autoScreenSaverTime: '自动屏保时间',
    displayDeviceSn: '显示SN',
    displayIp: '显示IP',
    displayIdentityCard: '显示云证',
    volume: '音量',
    language: '语言',
    displayCode: "显示小程序码",
    themeMode: "工作主题",
    cn: '中文',
    en: '英文',
    es: '西班牙语',
    fr: '法语',
    de: '德语',
    ru: '俄语',
    ar: '阿拉伯语',
    pt: '葡萄牙语',
    ko: '韩语',
    standardMode: '标准模式',
    simpleMode: '简约模式',
    firstLogin: '第一次登录后台',
    backlight: '屏幕背光',
    brightness: '白色补光灯',
    nirBrightness: '红外补光灯',
    never: '永不',
    min1: '1分钟',
    min2: '2分钟',
    min3: '3分钟',
    min4: '4分钟',
    min5: '5分钟',
    // 网络配置
    networkConfiguration: '网络配置',
    otherConfiguration: '其他配置',
    ipConfiguration: 'IP配置',
    devicePassword: '设备密码 ',
    protocolPassword: '通信协议密码',
    networkType: '网络类型 ',
    ethernet: '以太网',
    wifiName: 'Wi-Fi名',
    wifiPassword: 'Wi-Fi密码',
    dhcpModeSelection: 'DHCP模式',
    dhcpMode: '自动获取',
    customNetworkConfiguration: '手动配置',
    ipAddress: 'ip地址',
    gateway: '网关',
    subnetMask: '子网掩码',
    dnsServer: 'DNS服务器',
    mac: '网络mac',
    // MQTT配置
    mqttRelatedConfiguration: 'MQTT配置',
    mqttConnectionInformation: 'MQTT连接信息',
    sessionConfiguration: '会话配置',
    serverAddress: '服务器地址',
    clientID: '客户端ID',
    userName: '用户名',
    userPassword: '用户密码',
    topicPrefix: '主题前缀',
    onlineChecking: '在线验证',
    onlineCheckingTimeout: "在线验证超时",
    cleanSession: '清除会话',
    clientIdSuffix: '客户端ID后缀',
    willTopic: '遗嘱主题',
    enterpriseWechat:'企微模式无效',
    // 人脸配置
    faceRelatedConfiguration: '人脸配置',
    functionalInformation: '功能信息',
    prompt: '提示语',
    faceSimilarityThreshold: '人脸相似度阈值',
    livenessDetectionFunction: '活体检测功能',
    livenessDetectionThreshold: '活体检测阈值',
    infraredImageDisplay: "红外图像显示",
    maskRecognition: "口罩识别",
    strangerVoice: "陌生人语音",
    voiceMode: "语音模式",
    voiceModeDate: '自定义问候语',
    imageSaveType: "图像保存类型",
    saveStrangerImage: "保存陌生人图像",
    fullView: "全景",
    face: "人脸",
    broadcastPleaseRegisterFirst: '播放请先注册刷脸凭证',
    broadcastHelloStranger: '播放未登记人员',
    broadcastName: '播放名字',
    broadcastGreeting: '播放自定义问候语',
    greeting: '问候语  ',
    broadcastWelcome: '播放欢迎光临',
    recognitionSwitch: '重检开关',
    // 系统配置
    systemRelatedConfiguration: '系统配置',
    functionSwitch: '功能开关',
    cardSwipingSwitch: '刷卡开关',
    passwordSwitch: '密码开关',
    strangerImage: '陌生人图片开关',
    cloudCertificateSwitch: '云证开关',
    physicalCardNumber: '物理卡号',
    cloudCertificateAcquisition: '云证获取',
    heartbeatConfig: '心跳设置',
    heartbeatSwitch: '心跳开关',
    heartRateInterval: '心跳间隔',
    heartbeatTopic: '心跳主题',
    heartbeatContent: '心跳内容',
    basicInformation: '基础信息',
    deviceMac: 'mac地址',
    uuid: '设备uuid', 
    sn: '设备sn号',
    model: '设备型号',
    version: "版本号",
    appVersion: "固件版本号",
    releaseTime: "更新时间",
    totaldisk: '设备总空间',
    freedisk: '剩余空间',
    // 通行配置
    passageConfiguration: '通行配置',
    functionConfiguration: '功能配置',
    numberOfPassageRecords: '通行记录最大数量',
    durationOfRelayOpening: '继电器打开时长',
    alarmSwitch: '报警开关',
    fireAlarmSwitch: '火警开关',
    fireAlarmStatus: '火警状态',
    normal: '正常',
    warning: '预警',
    tamperSwitch: '防拆报警开关',
    uploadToCloudSwitch: '人脸上报开关',
    // 时钟配置
    clockConfiguration: '时钟配置',
    timeSynchronizationSwitch: '对时开关',
    timeSynchronizationServerIP: '对时服务器IP',
    timedSynchronizationTime: '定时同步时间',
    timeZone: '时区',
    setDeviceTime: '设置设备时间',
    restartAfterSetting: '操作后设备自动重启',
    // 云证激活
    cloudCertificateActivation: '云证激活',
    activationKey: '激活密钥',
    cloudTips1: '请输入激活密钥，确保没有空格',
    cloudTips2: '激活成功后设备将连接到云认证服务',
    confirmActivation: '确认激活',
    activationInProgress: '激活中...',
    activationFailed: '激活失败',
    activationSuccessful: '激活成功',
    // 密码修改
    passwordModification: '密码修改',
    password: '密码',
    oldPassword: '旧密码',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    passwordRule: '密码规则推荐',
    passwordLength: '长度≥6',
    cannotBeTheSame: '不能所有字符相同',
    cannotOrder: '不能包含至少3个连续数字或小写字母序列（升序或降序）',
    cannotWeakPassword: '不能是常见弱密码，包括',
    submit: '提交',
    saveConfig: '保存设置',
    // js中msg提示语
    msg_please_enter: '请输入内容',
    msg_inputPassword: '请输入密码',
    msg_oldPasswordError: '旧密码错误',
    msg_password_mismatch: '两次输入的密码不一致',
    msg_password_min_length: '密码长度至少为6位',
    msg_is_weak_password: '此密码为弱密码，请重新设置',
    msg_pswChangeSuccessAndLogin: '密码修改成功,请重新登录',
    msg_pswChangeSuccess: '密码修改成功',
    msg_pswChangeFail: '密码修改失败',
    msg_saveSuccess: '保存成功',
    msg_saveFail: '保存失败',
    msg_formFilled: '请检查表单填写是否正确',
    msg_number_0_23: '仅支持0到23',
    msg_number_0_24: '仅支持0到24',
    msg_noChange: '没有需要保存的配置变更',
    // 资源配置
    resourceConfiguration: '资源配置',
    backgroundImage: '背景图片',
    selectImage: '选择图片',
    uploadBackground: '上传背景',
    uploading: '上传中...',
    backgroundUploadTip: '请上传 像素为{n}的PNG格式 的图片，图片将转换为 Base64 格式后上传到设备',
    backgroundResolutionMismatch: '图片分辨率需为 {n}',
    backgroundRequired: '请先选择背景图片',
    backgroundImageOnlyPNG: '请上传 PNG 格式的图片',
    backgroundSizeLimit: '图片大小不能超过 5MB',
    backgroundParseFailed: '图片读取失败，请重试',
    backgroundImageSelected: '图片选择成功',
    backgroundSuccess: '背景上传成功',
    backgroundFailed: '背景上传失败',
    // 扫码设置
    scanSettings: '扫码设置',
    scanSwitch: '扫码开关',
    scanInterval: '扫码间隔',
  },
  // 人员设置 
  person: {
    idCard: '身份证号',
    userType: '人员类型',
    administrator: '管理员',
    userId: '人员ID',
    user: '人员',
    voucher: '凭证',
    permission: '权限',
    addUser: '添加人员',
    name: '姓名',
    editUser: '编辑人员',
    placeholderUserId: '请输入人员ID',
    placeholderName: '请输入人员姓名',
    userNotExist: '人员不存在',
    oneClickClear: '一键清空',
    clearTips: '此操作将永久删除所有人员、凭证和权限数据，是否继续？',
    clearSuccess: '清空成功',
    clearFailed: '清空失败',
  },
  
  voucher: {
    password: '密码',
    card: '卡片',
    face: '人脸',
    finger: '指纹',
    code: '码',
    codeType: '码类型',
    passthroughCode: '透传码',
    staticCode: '静态码',
    dynamicCode: '动态码',
    placeholderCode: '请输入码凭证',
    placeholderPwd: '请输入密码凭证',
    placeholderCard: '请输入卡片凭证',
    validPassword: '请输入6位数字',
    validCard: '请输入数字或字母',
    photoRegistration: '照片注册',
    featureValueRegistration: '特征值注册',
    fingerRegistration: '指纹注册',
    fingerFeatureRegistration: '特征值注册',
    fingerInput: '请将手指放在指纹采集器上',
    fingerRemainingTime: '剩余时间',
    fingerInputting: '录入中...',
    startFingerInput: '开始录入指纹',
    fingerInputTips: '请输入指纹特征值',
    fingerWaitInput: '等待录入',
    fingerInputNow: '正在录入指纹...',
    fingerInputSuccess: '录入成功',
    fingerInputFailed: '指纹录入启动失败',
    fingerReTry: '指纹录入失败,请重试',
    fingerFilled: '指纹录入成功，特征值已自动填充',
    fingerFailed: '指纹录入失败',
    fingerTimeout: '录入超时',
    fingerInputTimeout: '指纹录入超时,请重试',
    fingerError: '录入失败',
    fingerInputError: '指纹录入失败,请重试',
    fingerInputed: '指纹已录入',
    fingerReInput: '重新录入指纹',
  },
  
  permission: {
    deletePermission: '删除权限',
    addPermission: '添加权限',
    permissionId: '权限ID',
    userId: '人员ID',
    timeRange: '时间区间',
    extra: '额外属性',
    effectiveType: '有效类型',
    effectiveTime: '生效时段',
    effectiveWeek: '生效周期',
    timePeriod: '时间段',
    addTimePeriod: '添加时间段',
    modify_previous_time: '请先修改上一个添加的时间段',
    cannot_be_earlier: '结束时间不可小于开始时间',
    times_cannot_overlap: '所选时间不可重叠',
    choose_time_range: '请选择生效时间范围',
    unlimitedMode: '无限制',
    usualMode: '通常模式',
    dailyMode: '每日模式',
    weeklyRepetitionMode: '周重复模式',
    time_range: '时段',
  },
  
  common: {
    startDate: '开始日期',
    endDate: '结束日期',
    to: '至',
    cancel: '取消',
    confirm: '确认',
    close: '关闭',
    delete: '删除',
    edit: '编辑',
    batchDelete: '批量删除',
    startTime: '开始时间',
    endTime: '结束时间',
    monday: '星期一',
    tuseday: '星期二',
    wednesday: '星期三',
    thursday: '星期四',
    friday: '星期五',
    saterday: '星期六',
    sunday: '星期日',
    placeholder: '请输入',
    placeholderSelect: '请选择',
    closeTips: '确认关闭吗？',
    deleteTips: '确认删除吗？',
    deleteSuccess: '删除成功',
    addSuccess: '新增成功',
    editSuccess: '编辑成功',
    saveSuccess: '保存成功',
    tips: '提示',
    operation: '操作',
    query: '查询',
    reset: '重置',
    noData: '暂无数据',
    export: '导出',
    success: '成功',
    failure: '失败',
    incorrectFormat: '格式不正确',
    integerFormat: '只能为大于等于0的整数',
    positiveIntegerFormat: '只能为大于0的整数',
    noDataSaved: '没有数据需要保存',
    chinese: '中文',
    english: '英文',
    spanish: '西班牙语',
    french: '法语',
    german: '德语',
    russian: '俄语',
    arabic: '阿拉伯语',
    portuguese: '葡萄牙语',
    korean: '韩语',
    detail: '详情',
    clearTips: '确认清空吗?',
    clearSuccess: '清空成功',
  },
  
  log: {
    accessMethod: '通行方式',
    passingTime: '通行时间',
    accessPass: '通行凭证',
    accessResult: '通行结果',
    accessPhoto: '通行照片',
    viewPhotos: '查看照片'
  },

  error: {
    networkError: '网络请求失败，请检查网络连接',
    timeout: '请求超时，请检查网络连接或稍后重试',
    serverError: '服务器内部错误，请稍后重试',
    notFound: '请求的资源不存在',
    unauthorized: '未授权，请重新登录',
    noResponse: '无法连接到服务器，请检查网络连接或服务器状态',
    unknownError: '请求失败，错误代码:',
    requestFailed: '请求失败'
  },
  // 密钥管理
  security: {
    keyId: '密钥ID',
    keyType: '密钥类型',
    keyEncoding: '密钥编码',
    keyValue: '密钥值',
    startTime: '开始时间',
    expirationTime: '过期时间',
    newKey: '新增密钥',
    clearKey: '清空密钥',
    validTime: '有效时间',
  }
}